export default __webpack_public_path__ + "static/media/log-out.41271c61.png";